
export class AgentListingActivity {
  id: any;
  MediaURL: any;
  PropertyType: string;
  ListPrice: string;
  Address: Address;
  Bedrooms: any;
  Bathrooms: any;
  ListingStatus: string;
  iscustom: boolean;
  LotSize: any;
}

export class AgentActivityDetails {
  id: any;
  ListingStatus: any;
  MediaURL: any;
  PropertyType: any;
  PropertySubType: any;
  ListingCategory: any;
  ListPrice: any;
  Bedrooms: any;
  Bathrooms: any;
  Address: Address;
  ListingDescription: any;
  Style: string;
  MlsNumber: string;
  MlsName: string;
  LotSizeareaUnits: string;
  LotSize: string;
  YearBuilt: any;
  ListingID: string;
  DaysOnMarket: string;
  BrokerName: string;
  BrokerOffice: string;
  ListingURL: string;
  BathroomTypes: BathroomTypes;
  LivingAreaSize: string;
  ParkingInformation: string;
  Amenities: string;
  ArchitecturalStyle: string;
  RoofDescription: string;
  Disclaimer: string;
  Neighborhoods: string;
  Location: Location;
  MapLocation: string;
  ListingKey: string;
  Participant: Participant;
  LivingArea: string;
}

export class Address {
  FullStreetAddress: any;
  City: any;
  State: any;
  Country: any;
  PostalCode: any;
  UnitNumber: any;
}

export class BathroomTypes {
  FullBathrooms: string;
  ThreeQuarterBathrooms: string;
  HalfBathrooms: string;
  OneQuarterBathrooms: string;
  PartialBathrooms: string;
}

export class Location {
  Latitude: string;
  Longitude: string;
  Directions: string;
  County: string;
  ParcelId: string;
}
export class Participant {
  FirstName: string;
  LastName: string;
}
export class AgentUpdateActivity {
  ID: number;
  AgentID: number;
  FullStreetAddress: string;
  City: string;
  StateOrProvince: string;
  PostalCode: number;
  Country: string;
  ListPrice: number;
  Bedrooms: number;
  Bathrooms: number;
  PropertyType: string;
  PropertySubType: string;
  ListingCategory: string;
  ListingDescription: string;
  MlsName: string;
  MlsNumber: string;
  LotSizeareaUnits: string;
  LotSize: string;
  YearBuilt: string;
  LocationLatitude: string;
  LocationLongitude: string;
  IsCustom: string;
}
